export default __webpack_public_path__ + "static/Capterra-c8783cc3b26895582080365f5f71bf7a.svg";